import { motion } from "motion/react";
import styled from "styled-components";
import { StickySpy } from "react-sticky-spy";
import { useState } from "react";

const Container = styled(motion.div)`
    background: #5ec3e6;
    width: 100%;
    height: auto;
    display: flex;
    justify-content: center;
    gap: 2.5rem;

    position: sticky !important;
    top: 7.25rem;
    z-index: 10;
    overscroll-behavior-y: none;

    h2 {
        color: #fff;
        font-family: "Professor Marbles 3";
        font-size: 2.5rem;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    span {
        color: #fff;
        font-family: "Professor Marbles 3";
        font-size: 3.5rem;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    img {
        position: relative;
        bottom: -50px;

        height: 30.625rem;
    }

    &[data-react-is-sticky="false"] {
        height: 14rem;
    }

    &[data-react-is-sticky="true"] {
        img {
            transform: scale(0.65);
        }
        cursor: pointer;

        .sludge-wrapper {
            bottom: -3rem;
            left: -5rem;

            .ticket-info-container {
                .ticket-bg-text {
                    font-size: 1.2rem;
                    line-height: 1rem;
                }

                .ticket-value {
                    span {
                        line-height: 3.4rem;
                        font-size: 2rem;
                    }

                    span:nth-child(2) {
                        line-height: 3.7rem;
                        font-size: 3rem;
                    }
                }
            }
        }
    }

    .image-wrapper {
        position: relative;
        height: 100%;
        width: 15rem;

        img {
            position: absolute;
            height: 40rem;
            right: 0;
            /* inset: 0; */
            bottom: -120px;
        }
    }

    &[data-react-is-sticky="true"] {
        .right {
            flex-direction: row;
            align-items: center;
            overflow: hidden;

            @media (max-width: 1000px) {
                padding-left: 1rem;

                svg {
                    margin-left: -1rem;
                }
            }
        }

        .image-wrapper {
            display: flex;
            align-items: center;
            justify-content: center;

            @media (max-width: 1000px) {
                display: none;
            }
        }
    }

    .right {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-end;
        gap: 0.5rem;
        padding: 2rem 0;

        svg {
            color: #fff;
            width: 2.5rem;
            height: 2.5rem;
            margin: 0 2rem;
            /* stroke-width: .3; */
        }
    }

    @media (max-width: 1000px) {
        .image-wrapper {
            display: none;
            /* img {
                right: -8rem;
                bottom: -12rem;
            } */
        }

        .right {
            align-items: center;
            justify-content: center;
            text-align: center;
            padding: 2rem 0;
            /* padding-right: 2rem; */
        }
    }
`;

const StickyPrice = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20rem;
    height: 100%;
    z-index: 1;

    .sludge-wrapper {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20rem;
        height: 15rem;
        left: 0;
        bottom: 0;

        @media (max-width: 1000px) {
            left: -2rem;
            width: 15rem;
        }

        img {
            position: absolute;
            width: 15rem;
            height: auto;
            right: 1.8rem;
            bottom: 1rem;

            @media (max-width: 1000px) {
                right: 0rem;
                bottom: 1.5rem;
                width: 14.5rem;
            }
        }

        .ticket-info-container {
            display: flex;
            flex-direction: column;
            width: 60%;
            justify-content: center;
            align-items: center;
            transform: rotate(-6deg);

            @media (max-width: 1000px) {
                width: 80%;
            }

            .ticket-bg-text {
                position: relative;
                color: var(--dark-blue);
                font-family: "Professor Marbles 3";
                font-size: 2rem;
                line-height: 2.2rem;
                text-align: center;
                z-index: 1;
                letter-spacing: -2%;
            }

            .ticket-value {
                position: relative;
                display: flex;
                align-items: start;
                color: #fff;
                font-family: "Professor Marbles 3";
                letter-spacing: -5%;
                text-align: center;
                gap: 0.2rem;

                span {
                    line-height: 3.4rem;
                    font-size: 2.4rem;
                }

                span:nth-child(2) {
                    line-height: 3.7rem;
                    font-size: 4.4rem;
                }
            }
        }
    }
`;

export const CyanSection = () => {
    const [isSticky, setIsSticky] = useState(false);
    // Altura da página onde acontece o bug do elemento sticky: 898

    const handleScroll = () => {
        document
            .getElementById("calendar-section")!
            .scrollIntoView({ block: "center", behavior: "smooth" });
    };

    return (
        <StickySpy onStickyChange={setIsSticky}>
            <Container
                animate={
                    isSticky ? { height: "10rem", zIndex: 8 } : { zIndex: -1 }
                }
                onClick={handleScroll}
            >
                <div
                    className="image-wrapper"
                    style={
                        isSticky
                            ? {
                                  width: "10rem",
                                  height: "10rem",
                              }
                            : { zIndex: 1 }
                    }
                >
                    <motion.img
                        initial={{ y: 600 }}
                        whileInView={{ y: 0 }}
                        style={
                            isSticky
                                ? { height: "7.5rem", position: "static" }
                                : { zIndex: 0 }
                        }
                        transition={{ y: { duration: 0.5 }, duration: 0.25 }}
                        src="/smurfs/home-2.png"
                    ></motion.img>
                </div>
                <div className="right">
                    <h2>
                        Garanta seu <span>INGRESSO</span>
                    </h2>
                    <svg
                        width="32"
                        height="18"
                        viewBox="0 0 32 18"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ marginLeft: "9px" }}
                    >
                        <path
                            d="M2.08789 2.22705L15.3701 15L29.6069 2.22705"
                            stroke="white"
                            strokeWidth="4"
                            strokeLinecap="round"
                        />
                    </svg>
                </div>
                <StickyPrice>
                    <div className="sludge-wrapper">
                        <img
                            src="/cyan-section/green-sludge.png"
                            className="sludge no-shadow"
                            alt=""
                        ></img>
                        <div className="ticket-info-container">
                            <p className="ticket-bg-text">A partir de</p>
                            <div className="ticket-value blue-outline">
                                <span>R$</span>
                                <span>177</span>
                                <span>,30</span>
                            </div>
                        </div>
                    </div>
                </StickyPrice>
            </Container>
        </StickySpy>
    );
};
